import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import API_BASE_URL from '../config';
import '../login.css';
import logo from '../assets/logo.svg';

function Login({ setIsAuthenticated }) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [shakeLogo, setShakeLogo] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();

    try {
      const response = await fetch(`${API_BASE_URL}/api/login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ username, password })
      });

      if (response.ok) {
        const data = await response.json();
        localStorage.setItem('user', JSON.stringify({
          id: data.id,
          username: data.username,
          name: data.name,
          avatar: data.avatar || null
        }));
        setIsAuthenticated(true);
        navigate('/');
      } else {
        // Запускаем тряску логотипа
        setShakeLogo(true);
        setTimeout(() => setShakeLogo(false), 500); // Остановить через 500ms
      }
    } catch (error) {
      console.error('Помилка:', error);
    }
  };

  return (
    <div className="login-container">
      <img src={logo} alt="Logo" className={`logo ${shakeLogo ? 'shake' : ''}`} />
      <form className="login-form" onSubmit={handleLogin}>
        <input
          type="text"
          placeholder="Ім'я користувача"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
          required
        />
        <input
          type="password"
          placeholder="Пароль"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
        />
        <button type="submit">Увійти</button>
      </form>
    </div>
  );
}

export default Login;